import { templateScaleFactor } from "@/character/grid";

export type DownscaleSheetResult = {
  dataUrl: string;
  /** 1 = unchanged; 2+ = image was divided by this integer factor */
  appliedScale: number;
};

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("โหลดภาพไม่สำเร็จ"));
    img.src = src;
  });
}

/** Downscale integer-multiple template sheets (2×, 3×, …) to base 96 px cells. */
export async function downscaleSheetDataUrlIfOverscaled(
  dataUrl: string,
): Promise<DownscaleSheetResult> {
  const img = await loadImage(dataUrl);
  const w = img.naturalWidth;
  const h = img.naturalHeight;
  const factor = templateScaleFactor(w, h);
  if (factor == null || factor <= 1 || Math.abs(factor - Math.round(factor)) >= 0.001) {
    return { dataUrl, appliedScale: 1 };
  }
  const scale = Math.round(factor);
  const outW = Math.round(w / scale);
  const outH = Math.round(h / scale);
  const canvas = document.createElement("canvas");
  canvas.width = outW;
  canvas.height = outH;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("ลดขนาดภาพไม่สำเร็จ");
  }
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(img, 0, 0, outW, outH);
  return { dataUrl: canvas.toDataURL("image/png"), appliedScale: scale };
}
